import { Phone, MessageCircle, MapPin, Mail } from "lucide-react";

const WHATSAPP_URL = "https://wa.me/919891315777?text=Hi%2C%20I%20want%20to%20book%20a%20water%20tank%20cleaning%20service%20in%20Gurugram";
const LOGO_URL = "/logo.jpeg";

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-navy text-white py-16">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid md:grid-cols-5 gap-10">
          <div className="md:col-span-2">
            <div className="mb-4">
              <img
                src={LOGO_URL}
                alt="TankBuddy"
                className="h-10 w-auto rounded-md"
              />
            </div>
            <p className="font-heading text-sky font-medium text-base mb-3 tracking-wide">
              Clean Tank. Clean Water. Healthy Life.
            </p>
            <p className="text-slate-400 text-sm leading-relaxed max-w-md mb-6">
              Gurugram's most trusted premium water tank cleaning service. Professional, eco-friendly cleaning for residential, commercial, and hospitality water tanks.
            </p>

            <div className="space-y-3 mb-6">
              <a
                href="tel:+919891315777"
                data-testid="footer-phone-link"
                className="flex items-center gap-3 text-slate-300 hover:text-white transition-colors text-sm"
              >
                <Phone className="w-4 h-4 text-sky" />
                +91 98913 15777
              </a>
              <a
                href="mailto:info@tankbuddy.in"
                data-testid="footer-email-link"
                className="flex items-center gap-3 text-slate-300 hover:text-white transition-colors text-sm"
              >
                <Mail className="w-4 h-4 text-sky" />
                info@tankbuddy.in
              </a>
              <a
                href={WHATSAPP_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-whatsapp-link"
                className="flex items-center gap-3 text-slate-300 hover:text-white transition-colors text-sm"
              >
                <MessageCircle className="w-4 h-4 text-whatsapp" />
                Chat on WhatsApp
              </a>
              <div className="flex items-center gap-3 text-slate-300 text-sm">
                <MapPin className="w-4 h-4 text-sky" />
                Gurugram, Haryana, India
              </div>
            </div>

            <div className="flex items-center gap-3">
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-instagram-link"
                className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-sky transition-colors"
                aria-label="Instagram"
              >
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/></svg>
              </a>
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-facebook-link"
                className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-sky transition-colors"
                aria-label="Facebook"
              >
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
              </a>
              <a
                href={WHATSAPP_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-whatsapp transition-colors"
                aria-label="WhatsApp"
              >
                <MessageCircle className="w-4 h-4" />
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-sm uppercase tracking-[0.15em] text-slate-300 mb-4">
              Services
            </h4>
            <ul className="space-y-2 text-sm text-slate-400">
              <li><a href="/residential-tank-cleaning-gurugram" className="hover:text-white transition-colors">Residential Cleaning</a></li>
              <li><a href="/commercial-water-tank-cleaning-gurugram" className="hover:text-white transition-colors">Commercial Cleaning</a></li>
              <li><a href="/overhead-water-tank-cleaning-gurugram" className="hover:text-white transition-colors">Overhead Tank</a></li>
              <li><a href="/underground-water-tank-cleaning-gurugram" className="hover:text-white transition-colors">Underground Tank</a></li>
              <li><a href="/services" className="hover:text-white transition-colors">Hotel &amp; Hospitality</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-sm uppercase tracking-[0.15em] text-slate-300 mb-4">
              Quick Links
            </h4>
            <ul className="space-y-2 text-sm text-slate-400">
              <li><a href="/#process" className="hover:text-white transition-colors">Our Process</a></li>
              <li><a href="/#pricing" className="hover:text-white transition-colors">Pricing</a></li>
              <li><a href="/#contact" className="hover:text-white transition-colors">Contact Us</a></li>
              <li><a href="tel:+919891315777" className="hover:text-white transition-colors">+91 98913 15777</a></li>
              <li><a href="mailto:info@tankbuddy.in" className="hover:text-white transition-colors">info@tankbuddy.in</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-sm uppercase tracking-[0.15em] text-slate-300 mb-4">
              Blog
            </h4>
            <ul className="space-y-2 text-sm text-slate-400">
              <li><a href="/blog/how-often-clean-water-tank-gurugram" className="hover:text-white transition-colors">How Often to Clean Your Tank</a></li>
              <li><a href="/blog/signs-water-tank-needs-cleaning" className="hover:text-white transition-colors">Signs Tank Needs Cleaning</a></li>
              <li><a href="/blog/overhead-vs-underground-tank-cleaning" className="hover:text-white transition-colors">Overhead vs Underground Tank</a></li>
              <li><a href="/blog/waterborne-diseases-dirty-tanks-gurugram" className="hover:text-white transition-colors">Waterborne Diseases Gurugram</a></li>
              <li><a href="/blog/diy-vs-professional-tank-cleaning-gurugram" className="hover:text-white transition-colors">DIY vs Professional Cleaning</a></li>
            </ul>
          </div>

        </div>

        <div className="border-t border-white/10 mt-12 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-slate-500 text-xs">
            &copy; {new Date().getFullYear()} TankBuddy. All rights reserved. Premium Water Tank Cleaning Service in Gurugram, Haryana.
          </p>
          <p className="text-slate-500 text-xs">
            Serving Gurugram since 2020
          </p>
        </div>
      </div>
    </footer>
  );
}
